module.exports = __webpack_public_path__ + "img/dsa.90f9ce01.jpg";